import { updatesData } from '@/mocks/homeData';

const tagStyles: Record<string, string> = {
  '突发': 'bg-primary-100 text-primary-600',
  '独家': 'bg-accent-100 text-accent-600',
  '热议': 'bg-primary-100 text-primary-600',
  '官宣': 'bg-secondary-100 text-secondary-600',
  '现场': 'bg-accent-100 text-accent-600',
  '争议': 'bg-primary-100 text-primary-600',
  '定档': 'bg-secondary-100 text-secondary-600',
  '声明': 'bg-secondary-100 text-secondary-600',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-24 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 text-xs font-medium tracking-widest uppercase text-primary-500 bg-primary-50 px-3 py-1 rounded-full">
            <i className="ri-timer-flash-line"></i>实时滚动
          </div>
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 mt-4">
            最新快讯
          </h2>
          <p className="text-sm text-foreground-600 mt-2">每分钟都有新鲜瓜料上线</p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 border-l-2 border-primary-200 space-y-8">
            {updatesData.map((item, i) => (
              <div key={i} className="relative">
                <div className="absolute -left-[29px] top-1.5 w-4 h-4 rounded-full bg-primary-500 border-2 border-background-100"></div>
                <div className="flex flex-wrap items-start gap-2 mb-1">
                  <span className="text-xs text-foreground-500 font-medium">{item.time}</span>
                  <span
                    className={`text-xs font-bold px-2 py-0.5 rounded-full ${tagStyles[item.tag] || 'bg-background-200 text-foreground-600'}`}
                  >
                    {item.tag}
                  </span>
                </div>
                <p className="text-sm md:text-base font-medium text-foreground-900 leading-relaxed hover:text-primary-500 transition-colors duration-200 cursor-pointer">
                  {item.title}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}